import type { ErrorTranslations } from "./utils";

export default {
  already_public_servant: {
    EN: "Citizen is already a public servant",
    RO: "Cetățeanul este deja un funcționar public",
  },
  user_disabled: {
    EN: "User is disabled",
    RO: "Utilizatorul este dezactivat",
  },
} satisfies ErrorTranslations;
